import { ATTRS, TAGS } from '../constants';
import { EntitiesManager } from '../entitiesManager';
import { Entity, ISOFileInformation } from '../types';
import { parseXMLAttributes, encodeXMLAttributes } from '../time';

// Position is not implemented
export class AllocationStampEntity implements Entity {
  public static fromXML(
    xml: any,
    matchIDs: any,
    files: ISOFileInformation[],
    entitiesManager: EntitiesManager
  ) {
    const attrs = xml._attributes;
    const { start, stop, duration } = parseXMLAttributes(
      attrs[ATTRS.AllocationStamp.Start],
      attrs[ATTRS.AllocationStamp.Stop],
      attrs[ATTRS.AllocationStamp.Duration],
      entitiesManager.options.version
    );
    const timeType = attrs[ATTRS.Time.Type];
    return {
      entity: new AllocationStampEntity(timeType, start, stop, duration),
    };
  }

  public type = TAGS.AllocationStamp;

  constructor(
    public timeType: string,
    public start: number, // timestamp in milliseconds
    public stop: number = null, // timestamp in milliseconds
    public duration?: number // seconds
  ) {
    if (duration && !stop) {
      this.stop = start + duration * 1000;
    }

    if (stop && !duration) {
      this.duration = Math.round((stop - start) / 1000);
    }
  }

  public toXML(xmlId: string, entitiesManager: EntitiesManager) {
    const { startStr, stopStr, durationStr } = encodeXMLAttributes(
      this.start,
      this.stop,
      this.duration,
      entitiesManager.options.version
    );

    return {
      _attributes: {
        [ATTRS.Time.Start]: startStr,
        ...(stopStr && { [ATTRS.Time.Stop]: stopStr }),
        ...(durationStr && { [ATTRS.Time.Duration]: durationStr }),
        [ATTRS.Time.Type]: this.timeType,
      },
    };
  }
}
